import React from 'react';

import SelectCustomizableBase from 'core/modules/atoms/SelectCustomizable';
import TooltipCustomBase from 'core/modules/atoms/Tooltip/Tooltip';

type SelectOption = { label: string; value: string };

export const SelectCustomizable = SelectCustomizableBase as unknown as React.ComponentType<{
  closeMenuOnSelect?: boolean;
  components?: Record<string, React.ComponentType<any>>;
  isDisabled?: boolean;
  isLoading?: boolean;
  isMulti?: boolean;
  isSearchable?: boolean;
  label?: React.ReactNode;
  maxVisibleValues?: number;
  menuPosition?: 'absolute' | 'fixed';
  name?: string;
  onChange: (option: SelectOption | SelectOption[] | null) => void;
  options: SelectOption[];
  placeholder?: React.ReactNode;
  required?: boolean;
  size?: 'default' | 'small';
  value: SelectOption | SelectOption[] | null;
  variant?: 'default';
}>;

export const TooltipCustom = TooltipCustomBase as unknown as React.ComponentType<{
  aria?: 'describedby' | 'labelledby';
  arrow?: boolean;
  children: React.ReactElement;
  disabled?: boolean;
  placement?: string;
  title: React.ReactNode;
}>;
